{
  "AGENT_MGMT": {
    "HEADER": "Þjónustufulltrúar",
    "HEADER_BTN_TXT": "Bæta við þjónustufulltrúa",
    "LOADING": "Sækja lista yfir þjónustufulltrúa",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Stjórnandi",
      "AGENT": "Þjónustufulltrúi"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "Það eru engir þjónustufulltrúar tengdir við þennan reikning",
      "TITLE": "Umsýsla þjónustufulltrúa í þínu teymi",
      "DESC": "Þú getur bætt við/fjarlægt þjónustufulltrúa við/í liðinu þínu.",
      "NAME": "Nafn",
      "EMAIL": "NETFANG",
      "STATUS": "Staða",
      "ACTIONS": "Aðgerðir",
      "VERIFIED": "Staðfest",
      "VERIFICATION_PENDING": "Bíður staðfestingar",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Bæta þjónustufulltrúa við teymið",
      "DESC": "Þú getur bætt við fólki sem getur séð um þjónustu í innhólfinu þínu.",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "FORM": {
        "NAME": {
          "LABEL": "Nafn þjónustufulltrúa",
          "PLACEHOLDER": "Vinsamlegast skrifið nafn þjónustufulltrúa"
        },
        "AGENT_TYPE": {
          "LABEL": "Hlutverk",
          "PLACEHOLDER": "Vinsamlegast veljið hlutverk",
          "ERROR": "Hlutverk vantar"
        },
        "EMAIL": {
          "LABEL": "Netfang",
          "PLACEHOLDER": "Vinsamlegast skráið netfang þjónustufulltrúa"
        },
        "SUBMIT": "Bæta við þjónustufulltrúa"
      },
      "API": {
        "SUCCESS_MESSAGE": "Þjónustufulltrúa bætt við",
        "EXIST_MESSAGE": "Netfang þjónustufulltrúa nú þegar í notkun, vinsamlegast notið annað netfang",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eyða",
      "API": {
        "SUCCESS_MESSAGE": "Þjónustufulltrúa eytt",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      },
      "CONFIRM": {
        "TITLE": "Staðfesta eyðingu",
        "MESSAGE": "Ertu viss um að þú viljir eyða",
        "YES": "Já, eyða",
        "NO": "Nei, hætta við eyðingu"
      }
    },
    "EDIT": {
      "TITLE": "Breyta þjónustufulltrúa",
      "FORM": {
        "NAME": {
          "LABEL": "Nafn þjónustufulltrúa",
          "PLACEHOLDER": "Vinsamlegast skrifið nafn þjónustufulltrúa"
        },
        "AGENT_TYPE": {
          "LABEL": "Hlutverk",
          "PLACEHOLDER": "Vinsamlegast veljið hlutverk",
          "ERROR": "Hlutverk vantar"
        },
        "EMAIL": {
          "LABEL": "Netfang",
          "PLACEHOLDER": "Vinsamlegast skráið netfang þjónustufulltrúa"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Framboð",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "SUBMIT": "Breyta þjónustufulltrúa"
      },
      "BUTTON_TEXT": "Breyta",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "API": {
        "SUCCESS_MESSAGE": "Þjónustufulltrúa hefur verið breytt",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Endurstilla lykilorð",
        "ADMIN_SUCCESS_MESSAGE": "Tölvupóstur með leiðbeiningum um endurstillingu lykilorðs hefur verið sendur til þjónustufulltrúa",
        "SUCCESS_MESSAGE": "Lykilorð þjónustufulltrúa var endurstillt",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "SEARCH_PLACEHOLDER": "Leita að þjónustufulltrúum...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "Engar niðurstöður fundust."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Engin",
      "TITLE": {
        "AGENT": "Velja þjónustufulltrúa",
        "TEAM": "Velja teymi"
      },
      "LIST": {
        "NONE": "Enginn"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Engir þjónustufulltrúar fundust",
          "TEAM": "Ekkert teymi fannst"
        },
        "PLACEHOLDER": {
          "AGENT": "Leita að þjónustufulltrúum",
          "TEAM": "Leita að teymum",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
